<template>
  <div class="push-rule-bd tb" v-if="funcView.userAfterSale_list">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item></el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('asm_userAfterSale.ygxmdlzhfwqy')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table index :column="tableColumn" :data="tableList" @filter="filterChange" @sort="sortChange" height="100%">
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="editUserAfterSale(scope.row)" v-if="funcView.userAfterSale_edit">{{ funcView.userAfterSale_edit }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <application-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></application-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import applicationItemDialog from './children/userArea_item_dialog.vue';

export default {
  name: 'userAfterSale',
  components: { applicationItemDialog },
  data() {
    return {
      provide: true,
      tableCode: 'afterSaleRole_manage',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',

        parentId: '',
      },
      // 参数
      dialogVisible: false,
      dialogModel: {},
      tableList: [],
      totalRows: 0,
    };
  },

  mounted: function () {
    this.getUserAfterSale();
    this.getTableColumn();
    this.getFuncView();
  },
  methods: {
    // 获取消息规则列表
    getUserAfterSale: function () {
      this.$getJSON(apis.userAfterSaleRolePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getUserAfterSale();
    },
    // 编辑员工
    editUserAfterSale: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_userAfterSale.she_zhi_fu_wu_qu_yu');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss"></style>
